import { createTheme } from '@mui/material/styles';

const brand = {
  primary: '#1155cc',
  primarySoft: 'rgba(17, 85, 204, 0.12)',
  navy: '#1C2648',
  success: '#3EC28F',
  cream: '#F1E9E2',
  surface: '#F5F6FA',
  paper: '#FFFFFF',
  muted: '#6B7280',
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brand.primary,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: brand.navy,
    },
    success: {
      main: brand.success,
    },
    text: {
      primary: brand.navy,
      secondary: brand.muted,
    },
    background: {
      default: brand.surface,
      paper: brand.paper,
    },
    divider: 'rgba(28, 38, 72, 0.08)',
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: brand.navy,
      letterSpacing: '-0.02em',
      lineHeight: 1.3,
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: 600,
      color: brand.navy,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      color: brand.navy,
    },
    body1: {
      fontSize: '0.95rem',
      lineHeight: 1.6,
      color: brand.navy,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.55,
      color: brand.muted,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: 0,
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    'none',
    '0 1px 2px rgba(28, 38, 72, 0.04)',
    '0 4px 16px rgba(28, 38, 72, 0.06)',
    '0 8px 24px rgba(28, 38, 72, 0.08)',
    '0 12px 32px rgba(28, 38, 72, 0.1)',
    ...Array(20).fill('0 12px 32px rgba(28, 38, 72, 0.1)'),
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: brand.surface,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          minHeight: 48,
          paddingLeft: 24,
          paddingRight: 24,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(17, 85, 204, 0.25)',
            transform: 'translateY(-1px)',
          },
          transition: 'transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease',
        },
        containedPrimary: {
          '&:disabled': {
            backgroundColor: brand.primarySoft,
            color: brand.primary,
          },
        },
        outlined: {
          borderColor: 'rgba(17, 85, 204, 0.35)',
          color: brand.primary,
          '&:hover': {
            borderColor: brand.primary,
            backgroundColor: brand.primarySoft,
            boxShadow: 'none',
            transform: 'none',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 16,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: brand.surface,
          borderRight: '1px solid rgba(28, 38, 72, 0.08)',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 8,
          borderRadius: 8,
          backgroundColor: 'rgba(17, 85, 204, 0.12)',
        },
        bar: {
          borderRadius: 8,
          backgroundColor: brand.primary,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: brand.primary,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: brand.primary,
          fontWeight: 600,
        },
      },
    },
  },
});

export { brand };
export default theme;
